import React from 'react';
import { PropTypes } from 'prop-types';
import { Field } from 'react-final-form';
import { InputField, NoteDisclosure } from '@unite-us/app-components';
import { TextField } from '@unite-us/ui';
import DefaultAuthorizationFormFields from '../shared/DefaultAuthorizationFormFields';
import { ClinicalModificationsDropdown } from './ClinicalModificationsDropdown';

function AuthorizationDetailsSection({
  dateType,
  error,
  isUnitBased,
  isCostBased,
  feeScheduleProgram,
  initialClinicalModificationCodeValue,
}) {
  return (
    <>
      <hr className="my-5 border-dark-fill-blue border-solid" />
      <h4 className="uppercase leading-4 mb-3">
        Authorization Details
      </h4>
      <div className="grid grid-cols-2 gap-2 m-0 gap-x-24">
        <DefaultAuthorizationFormFields
          dateType={dateType}
          error={error}
          isUnitBased={isUnitBased}
          isCostBased={isCostBased}
          feeScheduleProgram={feeScheduleProgram}
          amountLabel="AUTHORIZED AMOUNT"
        />

        <Field name="payer_authorization_number">
          {(fieldProps) => (
            <InputField
              {...fieldProps}
              className="mb-0"
              id="payer_authorization_number"
              label="PAYER AUTHORIZATION ID"
            />
          )}
        </Field>
        {
          feeScheduleProgram.cm_code_required_on_authorization && (
            <ClinicalModificationsDropdown
              initialValue={initialClinicalModificationCodeValue}
            />
          )
        }

        <Field name="reviewer_note">
          {(props) => (
            <TextField
              {...props}
              className="!p-0 col-span-2"
              id="reviewer_note"
              label="NOTE"
              afterLabelContent={<NoteDisclosure />}
            />
          )}
        </Field>
      </div>
    </>
  );
}

AuthorizationDetailsSection.propTypes = {
  dateType: PropTypes.string.isRequired,
  error: PropTypes.string,
  isUnitBased: PropTypes.bool.isRequired,
  isCostBased: PropTypes.bool.isRequired,
  feeScheduleProgram: PropTypes.shape({
    unit: PropTypes.string,
    cm_code_required_on_authorization: PropTypes.bool,
  }).isRequired,
  initialClinicalModificationCodeValue: PropTypes.object,
};

AuthorizationDetailsSection.defaultProps = {
  error: undefined,
  initialClinicalModificationCodeValue: null,
};

export default AuthorizationDetailsSection;
